export default (props, {
  rhythm,
  scale,
  colors,
  radiuses
}) => ({
  root: {
    marginTop: rhythm(1)
  },
  modal: {
    container: {
      textAlign: 'center'
    }
  },
  link: {
    cursor: 'pointer',
    fontSize: scale(-0.5)
  },
  results: {
    root: {
      marginBottom: rhythm(0.75),
      textAlign: 'left'
    }
  },
  pagination: {
    marginBottom: rhythm(1)
  },
  error: {
    marginBottom: rhythm(0.75),
    padding: `${rhythm(0.5)} ${rhythm(0.75)}`,
    fontSize: scale(-0.75),
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: colors.danger,
    color: colors.light,
    borderRadius: rhythm(radiuses.small)
  }
})



// WEBPACK FOOTER //
// ./components/slices/Registration/TeamRegistration/styles.js